// extracted by mini-css-extract-plugin
export var resizer = "_fr-0";